import { Route, Routes, useNavigate } from 'react-router-dom';
import Login from '../screens/auth/login';
import HomeLayout from '../screens/home-layout';
import { PrivateRoute, privateRoutes } from './AllRoutes';
import ProtectedRoute from './ProtectedRoute';
import { usePermissions } from 'context/PermissionsContext';
import { useEffect, useMemo } from 'react';
import { selectToken, selectUserData } from 'store/auth/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { resetState } from 'store/auth';
import { message } from 'antd';

const buildRoutesRecursive = (
  routes: PrivateRoute[],
  parentPath = '',
): React.ReactNode[] => {
  return routes.map((route) => {
    const parentPrefix = parentPath === '/' ? '/' : `${parentPath}/`;
    const relativePath = route.path?.startsWith(parentPrefix)
      ? route.path?.substring(parentPrefix.length)
      : route.path;

    const routeElement = route.index ? (
      <Route key={route.key} index element={route.element} />
    ) : (
      <Route key={route.key} path={relativePath} element={route.element}>
        {route.children?.length &&
          buildRoutesRecursive(route.children, route.path)}
      </Route>
    );

    if (route.authorizedPermissions?.length) {
      return (
        <Route
          key={`${route.key}-wrapper`}
          element={
            <ProtectedRoute
              authorizedPermission={route.authorizedPermissions}
            />
          }
        >
          {routeElement}
        </Route>
      );
    }
    return routeElement;
  });
};

const AppContainer = () => {
  const { permissions } = usePermissions();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = useSelector(selectToken);
  const user = useSelector(selectUserData);

  const renderedRoutes = useMemo(
    () => buildRoutesRecursive(privateRoutes),
    [privateRoutes, permissions],
  );

  useEffect(() => {
    const storagePermission = localStorage.getItem('userPermissions');
    if (token && (!storagePermission || !user.userId)) {
      dispatch(resetState());
      navigate('/login');
      message.info('Session needs to be refreshed. Please log in again.');
    }
  }, []);

  return (
    <Routes>
      {/* { To prevent unauthenticated access } */}
      <Route path="/" element={<ProtectedRoute />}>
        <Route path="/" element={<HomeLayout />}>
          {renderedRoutes}
        </Route>
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Login />} />
    </Routes>
  );
};

export default AppContainer;
